module.exports = __webpack_public_path__ + "static/media/DocWithBubbles.4009d9d0.png";